export function createListItemHtml(listItem) {
    const li = document.createElement('li');
    const listButton = document.createElement('button');
    listButton.setAttribute('type', 'button');
    li.setAttribute('role', 'option');
    li.classList.add('spv-autocomplete__dropdownItem');
    li.setAttribute('id', 'spv-autocomplete__dropdownItem_' + listItem.posinset);
    li.innerHTML = '<span>' + listItem.item.substring(0, listItem.inputValue.length) + '</span>';
    li.innerHTML += listItem.item.substring(listItem.inputValue.length);
    li.setAttribute('data-value', listItem.item);
    li.setAttribute('aria-setsize', `${listItem.setsize}`);
    li.setAttribute('aria-posinset', `${listItem.posinset + 1}`);
    li.setAttribute('tabindex', '-1');
    return li;
}
//# sourceMappingURL=createListItemHtml.js.map